import { getGroupPermissionFactory, PermissionEnum } from '../../../../common';
import { CountriesPermissions } from './countries.permissions';

export class CountryStatesPermissions {
    static GroupName = `${CountriesPermissions.GroupName}.States`;

    static getPermissions = getGroupPermissionFactory(CountriesPermissions.GroupName);

    static Permissions = {
        ReadAll: CountryStatesPermissions.getPermissions(PermissionEnum.READ_ALL),
    };
}
